module.exports = __webpack_public_path__ + "img/moGaoKu2.0aa81233.png";